// frontend/src/services/bannerService.js
import api from "../config/api";

const bannerService = {
  // Obtener banners ativos (Home)
  getActiveBanners: async () => {
    try {
      const response = await api.get('/banners/active');
      return response.data;
    } catch (error) {
      console.error("Error fetching banners:", error);
      return { success: false, data: [] };
    }
  },

  // Obtener todos los banners (Admin)
  getAllBanners: async () => {
    try {
      const response = await api.get('/admin/banners');
      return response.data;
    } catch (error) {
      console.error("Error fetching banners:", error);
      return { success: false, data: [] };
    }
  },

  // Crear banner
  createBanner: async (formData) => {
    try {
      const response = await api.post('/admin/banners', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error("Error creating banner:", error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Erro ao criar banner' 
      };
    }
  },

  // Atualizar banner
  updateBanner: async (id, formData) => {
    try {
      const response = await api.post(`/admin/banners/${id}?_method=PUT`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      return response.data;
    } catch (error) {
      console.error("Error updating banner:", error);
      return { 
        success: false, 
        message: error.response?.data?.message || 'Erro ao atualizar banner' 
      };
    }
  },

  // Alternar status
  toggleActive: async (id) => {
    try {
      const response = await api.patch(`/admin/banners/${id}/toggle-active`);
      return response.data;
    } catch (error) {
      console.error("Error toggling banner:", error);
      return { success: false, message: 'Erro ao alterar status' };
    }
  },

  // Excluir banner
  deleteBanner: async (id) => {
    try {
      const response = await api.delete(`/admin/banners/${id}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting banner:", error);
      return { success: false, message: 'Erro ao excluir banner' };
    }
  }
};

export default bannerService;